import { MAIN_PAGE_FOOTER, MAIN_PAGE_HEADER } from './main';
import { TemplatePage } from './types';

const searchPage: TemplatePage = {
  header: MAIN_PAGE_HEADER,
  footer: MAIN_PAGE_FOOTER,
  content: [
    {
      type: 'templates',
      search: {}
    },
    {
      type: 'stocks',
      search: {}
    }
  ]
};

export default searchPage;
